import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'a360-print-backdrop',
  templateUrl: './print-backdrop.component.html',
  styleUrls: ['./print-backdrop.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PrintBackdropComponent {
  @Input()
  public title: string;

  @Input()
  public body: string;
}
